export const clientColumns = [
    { id: 'firstname', label: 'First Name' },
    { id: 'lastname', label: 'Last Name' },
    { id: 'email', label: 'Email' },
    { id: 'telephone', label: 'Telephone' },
    { id: 'dob', label: 'Date of Birth' },
    { id: 'address', label: 'Address' },
    { id: 'credit_report_link', label: 'Credit Report Link' },
    { id: 'cfa_signed_date', label: 'CFA Signed Date' },
    { id: 'introducer', label: 'Introducer' },
    { id: 'created_at_date', label: 'Created At Date' },
]

export const claimColumns = [
    { id: 'case_ref', label: 'Case Reference' },
    { id: 'policy_number', label: 'Policy Number' },
    { id: 'lender', label: 'Lender' },
    { id: 'start_date', label: 'Start Date' },
    { id: 'account_type', label: 'Account Type' },
    { id: 'lender_type', label: 'Lender Type' },
    { id: 'loan_amount_estimate', label: 'Loan Amount Estimate' },
    { id: 'starting_balance', label: 'Starting Balance' },
    { id: 'quantum_value', label: 'Quantum Value' },
    { id: 'all_quantum_fields', label: 'All Quantum Fields' },
    { id: 'cancelled', label: 'Cancelled' },
    { id: 'all_client_options', label: 'All Client Options' },
    { id: 'lead_created_at', label: 'Lead Created Date' },
    { id: 'cfa_signed_date', label: 'Esign Date' },
    { id: 'policy_number_assigned_date', label: 'Claim Creation Date' },
]

export const introducerOptions = [
    { value: 'ADL', label: 'All Day Loans' },
    { value: 'MR', label: 'CheckFinance' },
    { value: 'SO', label: 'SalesOne' },
    { value: 'SNT', label: 'Sentinel' },
    { value: 'PCPMO26', label: 'PCPMO26' },
]

// Approved lenders are no longer hardcoded here. Every picker reads the live
// list from the centralised approved-lender system via
// `useApprovedLenders` (src/helpers/approvedLenders.ts), which is backed by
// the funder-monitoring `funder_defendants` table (Admin > Approved Lenders).

export const startingBalanceOptions: Array<{ value: 'all' | boolean; label: string }> = [
    { value: 'all', label: 'All' },
    { value: true, label: 'Has Starting Balance' },
    { value: false, label: 'No Starting Balance' },
]

export const quantumValueOptions: Array<{ value: 'all' | boolean; label: string }> = [
    { value: 'all', label: 'All' },
    { value: true, label: 'Has Quantum Value' },
    { value: false, label: 'No Quantum Value' },
]
